<template>
  <router-view />
</template>

<script>

export default {
  name: 'L10nWrapper'
}
</script>
